import { useEffect, useState } from 'react';
import { getLocalCompanyId, getLocalJWT, getLocalUser, getLocalUserId } from '../functions/utilities';

const useAuth = () => {
    let token = getLocalJWT();
    let user = getLocalUser();
    let userId = getLocalUserId();
    let companyId = getLocalCompanyId();

    if (token != null && user != null && userId != null && companyId != null) {
        return true
    }
    return false
};

export default useAuth;